import React, {createContext, useContext} from 'react';
import {useStickyState} from "@lb/mlib-components";

const LocationsContext = createContext({
    locations: '',
    updateLocations: (locations) => {
    },

});

export const useLocations = () => {
    return useContext(LocationsContext);
};

export const LocationsProvider = ({children}) => {
        const [locations, setLocations] = useStickyState([], 'locations');

        const updateLocations = (locations) => {
            setLocations(locations);
        };

        const contextValue = {
            locations: locations,
            updateLocations: updateLocations
        };

        return (
            <LocationsContext.Provider value={contextValue}>
                {children}
            </LocationsContext.Provider>
        );
    }
;

export default LocationsContext